import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Checkbox } from "@air/primitive-checkbox";
import classNames from "classnames";
import { memo } from "react";
export const DefaultColorFilterControl = /*#__PURE__*/ memo((param)=>{
    let { colors, onClick, selectedColors } = param;
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex flex-col gap-2",
        "data-testid": "DEFAULT_COLOR_FILTER_CONTROL",
        children: [
            /*#__PURE__*/ _jsx("p", {
                className: "text-12 text-grey-12",
                children: "Default colors"
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "flex flex-wrap gap-1",
                children: colors.map((color)=>{
                    const isSelected = selectedColors.includes(color.hex);
                    const isWhite = color.name === "white";
                    return /*#__PURE__*/ _jsx("div", {
                        className: classNames("inline-flex size-6 items-center justify-center rounded-full", {
                            "border-2 border-grey-8": isSelected,
                            "border border-grey-5": !isSelected
                        }),
                        children: /*#__PURE__*/ _jsx(Checkbox, {
                            className: classNames("size-4 rounded-full", {
                                "border-grey-8 bg-white radix-state-checked:border-grey-8 radix-state-checked:bg-white radix-state-checked:text-black": isWhite && isSelected,
                                "border-grey-5 bg-white": isWhite && !isSelected,
                                "border-none": !isWhite
                            }),
                            style: {
                                backgroundColor: color.hex
                            },
                            "data-testid": "COLOR_FILTER_CHECKBOX",
                            "data-color-name": color.name,
                            checked: isSelected,
                            onCheckedChange: (checked)=>onClick({
                                    color,
                                    isSelected: !!checked
                                }),
                            size: "large"
                        })
                    }, color.hex);
                })
            })
        ]
    });
});
DefaultColorFilterControl.displayName = "DefaultColorFilterControl";
